import { Component, OnDestroy } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonToggleChange, MatButtonToggleGroup, MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatIconModule } from '@angular/material/icon'
import { EventLandingService } from '@app/modules/event-landing-page/services/event-landing.service'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'ngx-landing-breakpoints',
  templateUrl: './landing-breakpoints.component.html',
  styleUrls: ['./landing-breakpoints.component.scss'],
  imports: [CommonModule, MatButtonToggleModule, MatIconModule]
})
export class LandingBreakpointsComponent implements OnDestroy {
  private _destroy$ = new Subject()
  tab: string
  breakpoints: string[] = ['desktop', 'tablet', 'mobile']

  ngOnDestroy(): void {
    this._destroy$.next(null)
    this._destroy$.complete()
  }

  constructor(private landingService: EventLandingService) {
    this.landingService.changeBreakpoint.pipe(takeUntil(this._destroy$)).subscribe((newBreakpoint) => {
      this.tab = newBreakpoint
    })
  }

  onChangeToggle(event: MatButtonToggleChange, group: MatButtonToggleGroup) {
    if (event.value === this.tab) {
      this.tab = ''
      group.value = ''
      this.landingService.changeBreakpoint.next(undefined)
      return
    }
    this.tab = event.value
    this.landingService.changeBreakpoint.next(event.value)
  }
}
